import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import { router } from './lib/router';

import Vuex from 'vuex';
import store from './store/';



Vue.use(Vuex);
Vue.config.productionTip = false
new Vue({
  router: router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')

String.prototype.trunc = String.prototype.trunc ||
  function(n){
    return (this.length > n) ? this.substr(0, n-1) + '' : this;
};